import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { window, document } from '../../../helpers/BrowserHelpers';

var BlockActionWrapper =
/*#__PURE__*/
function (_Component) {
  _inherits(BlockActionWrapper, _Component);

  function BlockActionWrapper() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, BlockActionWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(BlockActionWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      top: 0,
      left: 0,
      width: 0,
      height: 0
    });

    _defineProperty(_assertThisInitialized(_this), "ticking", false);

    _defineProperty(_assertThisInitialized(_this), "requestPosition", function () {
      if (!_this.ticking) {
        _this.requestAnimationFrame = window.requestAnimationFrame(_this.computeWrapperPosition);
      }

      _this.ticking = true;
    });

    _defineProperty(_assertThisInitialized(_this), "computeWrapperPosition", function () {
      _this.ticking = false;
      var target = _this.props.target;

      var _target$getBoundingCl = target.getBoundingClientRect(),
          top = _target$getBoundingCl.top,
          left = _target$getBoundingCl.left,
          width = _target$getBoundingCl.width,
          height = _target$getBoundingCl.height;

      return _this.setState({
        top: top,
        left: left,
        width: width,
        height: height
      });
    });

    return _this;
  }

  _createClass(BlockActionWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('wheel', this.requestPosition, {
        passive: true
      });
      this.requestPosition();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.animationTimeout);
      window.cancelAnimationFrame(this.requestAnimationFrame);
      window.removeEventListener('wheel', this.requestPosition);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onBlockActionRef = _this$props.onBlockActionRef;
      var _this$state = this.state,
          top = _this$state.top,
          left = _this$state.left,
          width = _this$state.width,
          height = _this$state.height;
      return ReactDOM.createPortal(React.createElement("div", {
        ref: onBlockActionRef,
        className: "position-fixed no-print zindex-large",
        style: {
          top: top,
          left: left,
          width: width,
          height: height,
          pointerEvents: 'none',
          transition: 'opacity .2s ease-in-out',
          opacity: 1
        }
      }, children), document.body);
    }
  }]);

  return BlockActionWrapper;
}(Component);

_defineProperty(BlockActionWrapper, "propTypes", {
  children: PropTypes.any,
  onBlockActionRef: PropTypes.func,
  target: PropTypes.object
});

export { BlockActionWrapper as default };